export enum CompensationMode {
    new = 'new',
    additional = 'additional',
}
